module.exports = __webpack_public_path__ + "img/image5.cd3409bb.png";